<template>
  <div class="agreementDeclaration" :class="{'noProgressBar': isAccountStatusValid}">
    <Progress progress="91" v-if="!isAccountStatusValid"></Progress>
    <div class="title">{{ $t('agreementDeclaration.a000001') }}</div>
    <!-- <div class="hr"></div> -->
    <div class="item">
      <checkboxGroup v-model="agreementResult" >
        <checkbox class="checkText" v-for="item in agreements" :key="item.type" shape="square" :name="item.type"  >
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
          </template>
          <span class="underline-white" @click.stop="openAgreement(item)">{{ item.title }}</span>
        </checkbox>
      </checkboxGroup>
    </div>
    <!-- 按钮组 -->
    <navButtons :disabled="agreementResult.length < 7" @on-next="handNext" />
  </div>
</template>

<script>
import { Checkbox, CheckboxGroup, Toast } from 'vant';
import navButtons from '../components/navButtons.vue'
import Progress from '../components/Progress.vue'
import CheckNone from '@/assets/images/open-account/check_none.png'
import Checkd from '@/assets/images/open-account/check.png'
import { getBrowser } from "@/utils/browser";
import { setStatementDetailInfo } from "@/utils/hybirdMethods";
import { openAgreementPdf } from '../utils/resolveAgreementPdf'
export default {
  components: {
    Checkbox,
    CheckboxGroup,
    navButtons,
    Progress
  },
  data() {
    return {
      CheckNone,
      Checkd,
      pageType: 0,              // 进度判断
      agreementResult: [],      // 勾选结果
      account_status: 0,     // 是否加开
      agreements: [
        { type: 1, title: this.$t('agreementDeclaration.a000002') },
        { type: 11, title: this.$t('agreementDeclaration.a000020') },
        { type: 2, title: this.$t('agreementDeclaration.a000003') },
        { type: 3, title: this.$t('agreementDeclaration.a000004') },
        { type: 4, title: this.$t('agreementDeclaration.a000005') },
        { type: 5, title: this.$t('agreementDeclaration.a000006') },
        // { type: 6, title: this.$t('agreementDeclaration.a000008') },

        // { type: 7, title: '市场行情' },
        // { type: 8, title: '个人信息收集' },
        // { type: 9, title: '第三方SDK' },
        // { type: 10, title: '隐私保护政策' },
      ],
      openServerData: ''
    }
  },
  created() {
    if(getBrowser().isApp){
      setStatementDetailInfo({
        headerTitle: this.$route.meta.title,
        hideTitle: '0'
      })
    }
    this.init();
  },
  computed: {
    isAccountStatusValid() {
      const invalidStatuses = [0, 2, 3, 21];
      return this.openServerData?.process_id == 4 || !invalidStatuses.includes(this.account_status);
    }
  },
  methods: {
    init() {
      this.getRouter();
      this.getCachedData();
    },
    // 获取数据
    async getCachedData() {
      const defaultAgreementResult = [1, 2, 3, 4, 5, 6, 11]; // 7,8,9,10
      try {
        const { account_status, process_info } = await this.$apis.accountSituationV2({ step_code: '1,agreed_announcement,open_server,14' });

        this.account_status = account_status;
        this.openServerData = process_info?.open_server;
        // 根据account_status选择正确的process_info
        const selectedProcessInfo = this.isAccountStatusValid ?
          process_info?.['agreed_announcement'] :
          process_info?.[14];

        let agreementResult = [];

        if (selectedProcessInfo?.config_data) {
          const configData = JSON.parse(selectedProcessInfo.config_data || '[]');

          // 只有当configData是非空数组时才更新agreementResult
          if (Array.isArray(configData) && configData.length > 0) {
            agreementResult = configData;
          }
        }

        // 如果没有从接口获取到数据，则使用默认值
        if (agreementResult.length == 0) {
          agreementResult = defaultAgreementResult;
        }

        this.agreementResult = agreementResult;

        this.handleProcessId(process_info);

      } catch (error) {
        
        // 设置默认值，以防止用户界面显示为空
        this.agreementResult = defaultAgreementResult;
      }
    },
    // 进度条显示判断
    getRouter() {
      this.pageType = this.$route.query.add || 0
    },
    handleProcessId(process_info) {
      // 加开就默认是4，首开从第一步取数据
      this.process_id = this.isAccountStatusValid
        ? 4
        : process_info[1]?.process_id || 1;
    },
    // 下一步
    async handNext() {
      if ( this.agreementResult.length < 7 ) return false;
      const loading = Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: "spinner",
        message: this.$t("common.loading_text")
      });
      await this.reportData();
      let path = '/open-account/face-recognition';
      // 加开跳过人脸识别
      if ( this.isAccountStatusValid ) {
        path = '/open-account/customerConfirmation';
      }
      this.$router
          .push(path)
          .finally(() => {
            loading.clear();
          });
    },
    // 打开协议 PDF（enum 绝对地址）
    openAgreement(item) {
      openAgreementPdf(item.type, item.title);
    },
    async reportData() {
      const query = {
        process_id: this.process_id, step_code: 14, step_order: 14,
        config_data: this.agreementResult
      }
      // 加开的情况下修改key
      if ( this.isAccountStatusValid ) {
        query.step_code = 'agreed_announcement';
        query.step_order = 5;
      }
      await this.$apis.supplementSaveApi(query);
    }
  }
}
</script>

<style scoped lang="less">
.agreementDeclaration {
  background: white;
  min-height: 100vh;
  padding: 62px 0px;
  &.noProgressBar {
    padding-top: 22px !important;
  }
  .title {
    font-size: 36px;
    font-weight: 500;
    color: #17161c;
    min-height: 88px;
    line-height: 1.2;
    padding: 14px 32px 0;
    border-bottom: #f3f3f3 solid 1px;
    display: flex;
    align-items: center;
  }
  .item {
    margin: 40px 34px 0px;
    .checkText {
      font-size: 32px;
      // text-decoration: underline;
      color: #17161c;
      line-height: 32px;
      margin-bottom: 44px;
      .underline-white {
        position: relative;
        display: inline-block; /* 确保只对文本部分应用 */
        cursor: pointer; /* 提示用户可以点击 */
      }

      .underline-white::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px; 
        background-color: black; 
        z-index: 1;
      }
    }
  }
}
.black-theme {
  .agreementDeclaration {
    background: #1B1C24 !important;
    .title {
      color: white;
      border-bottom-color: #323442;
    }
    .underline-white::after {
      background-color: white !important; 
    }
  }
}
// icon
.img-icon{
  width: 28px;
  height: 28px;
}
.hr{
  border-bottom: 1px solid #F3F3F3;
  width: 130%;
  margin-left: -40px;
  margin-bottom: 26px;
}
</style>
